// @flow

import React from 'react'
import styled from 'styled-components'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'

const ReservationHelpBlockWrapper = styled.div`
  padding: ${spacing.medium_2}px;
  text-align: center;
  border: 1px solid ${Colors.grayE};
  border-radius: ${borderRadius}px;
`
const Title = styled.p`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;

  &:not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const LinkTextWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`

type PropTypes = {}

export default function ReservationHelpBlock(props: PropTypes) {
  return (
    <ReservationHelpBlockWrapper>
      <Title>{i18n.t('page.dashboard.reservation.helpLead')}</Title>
      <LinkTextWrapper>
        <LinkText
          href="https://help.spacemarket.com/hc/ja/sections/360000135187-%E3%82%88%E3%81%8F%E3%81%82%E3%82%8B%E8%B3%AA%E5%95%8F"
          target="_blank"
        >
          {i18n.t('page.dashboard.reservation.helpLink')}
          <Icon className="fa fa-angle-right" positionType="right" />
        </LinkText>
      </LinkTextWrapper>
    </ReservationHelpBlockWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationHelpBlock/index.jsx